export default "__VITE_ASSET__BkoLtlcu__"